import React from 'react';
import styled from 'astroturf/react';
import { Button } from 'js/design_system/Button';
import _Icon from "common-Icon.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/churned_user_reactivation/common.tsx?styleId=Icon";
import _Text from "common-Text.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/churned_user_reactivation/common.tsx?styleId=Text";
import _ActionButton from "common-ActionButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/churned_user_reactivation/common.tsx?styleId=ActionButton";


const Icon = /*#__PURE__*/styled("div", null, {
  displayName: "Icon",
  styles: _Icon
});

const Text = /*#__PURE__*/styled("div", null, {
  displayName: "Text",
  styles: _Text
});

const ActionButton = /*#__PURE__*/styled(Button, null, {
  displayName: "ActionButton",
  styles: _ActionButton
});

type Props = {
  buttonContent: string | React.ReactNode;
  clickThrough: () => void;
};

export const CommonButton = ({ buttonContent, clickThrough }: Props) => {
  return (
    <ActionButton onClick={clickThrough}>
      <Icon />
      <Text>{buttonContent}</Text>
    </ActionButton>
  );
};
